import { render, staticRenderFns } from "./ERegistrationCPSRegisterView.vue?vue&type=template&id=253ce687&scoped=true&"
import script from "./ERegistrationCPSRegisterView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationCPSRegisterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ce687",
  null
  
)

export default component.exports